// cart page section start
$(document).ready(function(){
  function numberWithCommas(number) {
      var parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
  }
  $(document).on('change','#ckbCheckAll', function() {
        if ($("#ckbCheckAll").is(':checked')){
          $('.custom-cart-note').css('display','none');
          $(".checkBoxClass").each(function (){
             $(this).prop("checked", true);
              var $this = $(this);
              var parentclass = $this.parent().parent()
              var producttitle = parentclass.find('.cart__item--title').text();
              var productqty = parentclass.find('.quantity').val();
              var bundleProductcurrency = parentclass.find('.modal_price .money').attr('data-currency');
              var bundleProductPrice =  parentclass.find('.modal_price .money.mainprice').attr('data-money');
              var producttotlaprice = parentclass.find('.modal_price .money').text();
              var bundleProductId = $this.val();
              var productTotal = bundleProductPrice*productqty;
              var carttotalprice = $('.cart-page-subtotal').children().find('.money');
              var carttotalpriceattr = $('.cart-page-subtotal').attr('data-maintotal-price');
              console.log(bundleProductPrice,productqty,productTotal.toFixed(2));
              if($('.overview-product[data-id="'+bundleProductId+'"]').length <= 0){
                  var bundleHtml = '';
                  bundleHtml +=`<li class="overview-product" data-id="${bundleProductId}">
                  <div class="overview-product-box">
                  <span class="overview-product-qty"> ${productqty} X</span>
                  <span class="overview-product-title">${producttitle}</span>
                  </div>
                  <div class="overvie-title">
                  <span class="overview-product-price" data-price="${productTotal}">${bundleProductcurrency}${numberWithCommas((productTotal).toFixed(2))}</span>
                  </div> 
                </li>`;
                console.log(bundleHtml);
                $('.cartsubtotalitem').append(bundleHtml);
              }else{
                  $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-title').text(producttitle);
                  $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-qty').text(productqty + ' ' + 'X');
                  $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').text(bundleProductcurrency+numberWithCommas((productTotal).toFixed(2)));
                  $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').attr('data-price',bundleProductPrice);
              }
              var totalprice = parseFloat(carttotalpriceattr)
              $(carttotalprice).text(bundleProductcurrency+numberWithCommas((totalprice).toFixed(2)));
              $(carttotalprice).attr('data-total-price',numberWithCommas((totalprice).toFixed(2)));
          });
        }
        else{
           $(".checkBoxClass").each(function (){
               var $this = $(this);
               var bundleProductId = $this.val();
               $(this).prop("checked", false);
               $('.overview-product[data-id="'+bundleProductId+'"]').remove();
           });
        }
    });   
  $(document).on('change','.cart__item .checkBoxClass', function(){
        var $this = $(this);
        var parentclass = $this.parent().parent()
        var producttitle = parentclass.find('.cart__item--title').text();
        var productqty = parentclass.find('.quantity').val();
        var bundleProductcurrency = parentclass.find('.modal_price .money').attr('data-currency');
        var bundleProductPrice =  parentclass.find('.modal_price .money.mainprice').attr('data-money');
        var producttotlaprice = parentclass.find('.modal_price .money').text();
        var bundleProductId = $this.val();
        var productTotal = bundleProductPrice*productqty;
        var carttotalprice = $('.cart-page-subtotal').children().find('.money');
        console.log(carttotalprice);
        console.log(bundleProductPrice,productqty,productTotal.toFixed(2));
        
        if(this.checked){
            $('.custom-cart-note').css('display','none');
            $('.overview-product').css('display','flex');
            if($('.overview-product[data-id="'+bundleProductId+'"]').length <= 0){
                var bundleHtml = '';
                bundleHtml +=`<li class="overview-product" data-id="${bundleProductId}" style="display:flex;">
                <div class="overview-product-box">
                  <span class="overview-product-qty"> ${productqty} X</span>
                  <span class="overview-product-title">${producttitle}</span>
                  </div>
                  <div class="overvie-title">
                  <span class="overview-product-price" data-price="${productTotal}">${bundleProductcurrency}${numberWithCommas((productTotal).toFixed(2))}</span>
                  </div>
              </li>`;
              console.log(bundleHtml);
              $('.cartsubtotalitem').append(bundleHtml);
                
            }else{
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-title').text(producttitle);
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-qty').text(productqty + ' ' + 'X');
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').text(bundleProductcurrency+numberWithCommas((productTotal).toFixed(2)));
                $('.overview-product[data-id="'+bundleProductId+'"] .overview-product-price').attr('data-price',bundleProductPrice);
            }
        }
        else{
            $('.overview-product[data-id="'+bundleProductId+'"]').remove();
            $('#ckbCheckAll').prop("checked", false);
            $('.overview-product').css('display','flex');
        }
        var total = 0;
        $('.cart__item .checkBoxClass').each(function(){
          if(this.checked){
             var $this = $(this);
             var parentclass = $this.parent().parent() 
             var bundleProductPrice =  parentclass.find('.price_total .money').attr('data-money');
             total += parseFloat(bundleProductPrice);
             console.log(total,'total');
             $(carttotalprice).text(bundleProductcurrency+numberWithCommas((total).toFixed(2)));
             $(carttotalprice).attr('data-total-price',numberWithCommas((total).toFixed(2)));
          }
        });
    });
  $('#customcheckout').click(function() {
    var lengthOfUnchecked = $('input.checkBoxClass:checkbox:not(:checked)').length;
    var cartitemlength = $('.cart__item').length;
    if($('.ckbCheckAll').prop('checked')){
      $('#checkout').trigger('click');
    }
    else{
      var lineItem  = [];
      var cartitemlenth = '';
        $(".cart__item").each(function (){
          var cartitemlenth = $(this).lenght;
          var thischeckbox = $(this).children('.checkBoxClasstd').find('.checkBoxClass');
          var customproductid = $(thischeckbox).attr('data-id-key');
          if($(thischeckbox).prop('checked')==false){   
              var item = customproductid;    
              lineItem.push(item);
          }
        });
        
        console.log(lineItem,'unseleteddata');
        var qty = 0;    
        var data = { updates: {} }; 
         for (i = 0; i < lineItem.length; i++)  {    
             console.log(lineItem[i],qty);  
             data.updates[lineItem[i]] = qty;   
         }    
        console.log(data,'unseleteddataarray',cartitemlength == lengthOfUnchecked);
        if(cartitemlength == lengthOfUnchecked){
          $('.custom-cart-note').css('display','block');
        }
        else{
          $('.custom-cart-note').css('display','none');
          $.ajax({
              type:'post',
              url:'/cart/update.js',
              data: data,
              dataType: 'json',
              success:function(data){
                  console.log(data,'updatecartdata');
                  $('#checkout').trigger('click');
              }
          });
        }
            
    }
});
});


$(document).ready(function(){
  $('.discount-button').click(function(){
    console.log('discount')
    if($('.discount-code input').val().length > 0){
      $('#customcheckout').trigger('click');  
    }
  });
});

function isFullyInViewport($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementTop >= viewportTop && elementBottom <= viewportBottom && elementTop <= viewportBottom && elementBottom >= viewportTop;
}
$(window).on('resize scroll', function() {
  if($('body.custom-productpage').length) {
    var divAddtoCart = $(".shopify-product-form").position();
    var scrollTo = divAddtoCart.top +  $(".shopify-product-form").height();
    console.log()
    if ($(this).scrollTop()>scrollTo) {
      $('.extra-add-to-cart').removeClass('hidden');
    } else {
      $('.extra-add-to-cart').addClass('hidden');
    } 
  }
});
$(window).on('resize scroll', function() {
  if($('body.custom-cartpage').length) {
    var divAddtoCart = $(".continue-shopping").position();
    var scrollTo = divAddtoCart.top +  $(".continue-shopping").height();
    if ($(this).scrollTop() > scrollTo) {
      $('.tos_warning.checkout_button').removeClass('non-sticky');
      $('.tos_warning.checkout_button').addClass('chk-sticky');
    } else {
      $('.tos_warning.checkout_button').addClass('non-sticky');
      $('.tos_warning.checkout_button').removeClass('chk-sticky');
    } 
  }
});
 $(document).ready(function() {
    $('.extra-add-to-cart .add_to_cart').on('click', function(event) {
      event.preventDefault();
      var target = $(this).attr('data-href');
      $('html, body').animate({
        scrollTop: $(target).offset().top-150
      }, 1000); // Change the duration (in milliseconds) for different scrolling speeds
    });
     $(".product-quantity-block .quantity").keydown(function(event) { 
          return false;
      });
  });

$(document).ready(function() {
    $(".product_banner iframe").each(function( index ) {
       var myClass = $(this).attr('class');
       $(this).closest('div').addClass(myClass);
    });
    $('.gift-code-box').click(function(){
      
    })
  
});
